<mat-form-field class="w-full" cdkScrollable>
  <mat-label>Default Commodity</mat-label>
  <input
    #input
    type="text"
    matInput
    [formControl]="newDefaultCommodity"
    [matAutocomplete]="defaultAuto"
    (input)="filter($event)"
    (focus)="filter($event)"
  />
  <mat-autocomplete requireSelection #defaultAuto="matAutocomplete">
    @for (option of filteredOptions; track option) {
    <mat-option [value]="option" (click)="saveNewCommmodity()">{{
      option
    }}</mat-option>
    }
  </mat-autocomplete>
</mat-form-field>

<mat-form-field class="w-full">
  <mat-label class="text-sm">Favourite Commodities</mat-label>
  <mat-select
    [formControl]="favCommodityCtrl"
    (selectionChange)="newFavouriteCommodities()"
    multiple
  >
    @for (comm of favouriteOptions(); track comm) {
    <mat-option [value]="comm">{{ comm }}</mat-option>
    }
  </mat-select>
</mat-form-field>
